var map = {
	"./pdf": 47,
	"./pdf.js": 47,
	"./pdf.js.map": 6419,
	"./pdf.min": 303,
	"./pdf.min.js": 303,
	"./pdf.worker": 61,
	"./pdf.worker.entry": 304,
	"./pdf.worker.entry.js": 304,
	"./pdf.worker.js": 61,
	"./pdf.worker.js.map": 6420,
	"./pdf.worker.min": 305,
	"./pdf.worker.min.js": 305
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81;



//////////////////
// WEBPACK FOOTER
// ./~/pdfjs-dist/build ^\.\/.*$
// module id = 81
// module chunks = 0